export default class Stores {
  static AuthenticationStore = "authenticationStore"
  static RoleStore = "roleStore"
  static BundleStore = "bundleStore"
  static TenantStore = "tenantStore"
  static UserStore = "userStore"
  static SessionStore = "sessionStore"
  static AccountStore = "accountStore"
  static LanguageStore = "languageStore"
  static AppDataStore = "appDataStore"

  /** Thanh progress loading dùng chung dưới header */
  static UiProgressStore = "uiProgressStore"

  /** Download Request Center — danh sách yêu cầu tải + cờ mở drawer dùng chung */
  static DownloadRequestStore = "downloadRequestStore"

  // Master data
  static MasterDataStore = "masterDataStore"
  static CustomerSourceStore = "customerSourceStore"
  static ProjectFacilityStore = "projectFacilityStore"
  static TownShipStore = "townShipStore"
  static UnitDesignStore = "unitDesignStore"
  static UnitFacilityStore = "unitFacilityStore"
  static UnitTypeStore = "unitTypeStore"
  static ProjectMasterStore = "projectMasterStore"
  static UnitMasterStore = "unitMasterStore"
  static ZoneStore = "zoneStore"
  static FloorStore = "floorStore"
  static TowerStore = "towerStore"
  static PaymentMasterStore = "paymentMasterStore"
  static PropertyTypeStore = "propertyTypeStore"
  static ViewStore = "viewStore"
  static PaymentRequestStore = "paymentRequestStore"
  static GroupStore = "groupStore"
  static CompanyPrintTemplateStore = "companyPrintTemplateStore"

  // Resident & Staff & Shop owner
  static StaffStore = "staffStore"
  static PartnerStore = "partnerStore"

  // News & Event
  static NewsCategoryStore = "newsCategoryStore"

  // Finance
  static FinanceStore = "financeStore"
  static WithdrawStore = "withdrawStore"
  static CashAdvanceStore = "cashAdvanceStore"
  static ReceiptStore = "receiptStore"
  static ExpenseMandateStore = "expenseMandateStore"
  static FeeTypeStore = "feeTypeStore"
  static InquiryFeeTypeSettingStore = "inquiryFeeTypeSettingStore"

  // Workflow
  static WfStatusStore = "wfStatusStore"
  static WfPriorityStore = "wfPriorityStore"
  static WfRoleStore = "wfRoleStore"
  static WfTrackerStore = "wfTrackerStore"
  static WfCustomFieldStore = "wfCustomFieldStore"
  static WfConfigurationStore = "wfConfigurationStore"
  static WorkflowStore = "workflowStore"

  // File
  static FileStore = "fileStore"
  // Import/export
  static ImportStore = "importStore"

  // Common
  static AuditLogStore = "auditLogStore"
  static CommentStore = "commentStore"
  static NotificationTemplateStore = "notificationTemplateStore"

  // Notification Center
  static NotificationCenterStore = "notificationCenterStore"

  // Notification Delivery Tracking
  static NotificationDeliveryStore = "notificationDeliveryStore"

  // Notification Audit Log
  static NotificationAuditLogStore = "notificationAuditLogStore"

  // Reminder
  static ReminderStore = "reminderStore"
  // Client Management
  static CompanyStore = "companyStore"
  static ContactStore = "contactStore"

  // Opportunity
  static OpportunityStore = "opportunityStore"
  //organizationUnit
  static OrganizationUnitStore = "organizationUnitStore"
  // Activity
  static ProposalStore = "proposalStore"
  static ActivityStore = "activityStore"
  static CallStore = "callStore"
  static MailStore = "mailStore"
  static ReservationStore = "reservationStore"
  static SiteVisitStore = "siteVisitStore"
  static MeetingStore = "meetingStore"
  static CalendarStore = "calendarStore"
  static DepositStore = "depositStore"

  // Project
  static RequirementStore = "requirementStore"
  static UnitStore = "unitStore"
  static ListingStore = "listingStore"

  // Campaign
  static CampaignStore = "campaignStore"
  static TargetStore = "targetStore"

  // Inquiry

  static OpportunityCommercialStore = "opportunityCommercialStore"

  static DashboardStore = "dashboardStore"
  static ReportStore = "reportStore"

  // CRM
  static FilterStore = "filterStore"
  static FeedbackStore = "feedbackStore"
  static SaleEventStore = "saleEventStore"
  static PinkBookStore = "pinkBookStore"
  static ContractStore = "contractStore"

  static PromotionProgramStore = "promotionProgramStore"
  static SalePolicyStore = "salePolicyStore"
  static PaymentScheduleStore = "paymentScheduleStore"

  static CustomerStore = "customerStore"
  static CustomerPotentialStore = "customerPotentialStore"

  static BookingStore = "bookingStore"
  static BookingReservationStore = "bookingReservationStore"
  static CartStore = "cartStore"
  static ApprovalStore = "approvalStore"
  static HandoverStore = "handoverStore"
  static InvitationStore = "invitationStore"
  static PricingApprovalStore = "pricingApprovalStore"
  static ContractEventStore = "contractEventStore"
  static ContractInquiryStore = "contractInquiryStore"
  static InquiryStore = "inquiryStore"
  // Trading Floor
  static AgencyMasterStore = "agencyMasterStore"
  // Floor and Staff
  static TradingFloorStore = "tradingFloorStore"
  static FloorStaffStore = "floorStaffStore"
  static BussinessTargetStore = "bussinessTargetStore"
  static AllocatedCustomerStore = "allocatedCustomerStore"

  //configuration Payment
  static ConfigurationPaymentStore = "configurationPaymentStore"

  //phaseCodeStore
  static PhaseCodeStore = "phaseCodeStore"

  //systemConfigurationStore
  static SystemConfigurationStore = "systemConfigurationStore"

  //ApprovalProcessStore
  static ApprovalProcessStore = "approvalProcessStore"

  // Accounting Data
  static AccountTypeStore = "accountTypeStore"
  static AccountingDocumentTypeStore = "accountingDocumentTypeStore"
  static CostCenterStore = "costCenterStore"
  static OffsetAccountStore = "offsetAccountStore"
  static SuspenseAccountSettingStore = "suspenseAccountSettingStore"

  //ConfigHoliday
  static ConfigHolidayStore = "configHolidayStore"

  // Fee Notification
  static FeeNotificationStore = "feeNotificationStore"

  static FeeReminderLadderStore = "feeReminderLadderStore"

  // Fee Notification Reporting (dashboard + ma trận + 4 danh sách hành động)
  static FeeNotificationReportStore = "feeNotificationReportStore"

  //BlockUserStore
  static BlockUserStore = "blockUserStore"

  //ContractInterestSettingStore
  static ContractInterestSettingStore = "contractInterestSettingStore"

  // Import Job Log
  static ImportJobLogStore = "importJobLogStore"

  // Integration Result
  static IntegrationResultStore = "integrationResultStore"

  // Integration Hub
  static IntegrationHubStore = "integrationHubStore"

  // Approval Inbox Outbox
  static ApprovalInboxOutboxStore = "approvalInboxOutboxStore"

  // PinkBook Fee Update
  static PinkBookFeeUpdateStore = "pinkBookFeeUpdateStore"

  // Approver Group
  static ApproverGroupStore = "approverGroupStore"

  // Dashboard Suite (Feature-0197…0200)
  static DashboardCsStore = "dashboardCsStore"
  static DashboardFinanceStore = "dashboardFinanceStore"
  static DashboardSalesStore = "dashboardSalesStore"
  static DashboardExecutiveStore = "dashboardExecutiveStore"
  static Entity360Store = "entity360Store"

  // Export Job Log (Feature-0213 Export Core)
  static ExportJobLogStore = "exportJobLogStore"

  // Mẫu mã tự sinh (Feature-0371)
  static CodeFormatTemplateStore = "codeFormatTemplateStore"
}
